// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { PaginatedList } from "@types";
import type { EmployeeType } from "@modules/employee/types";
import { GSGrid, Icons, Pagination } from "@components";
import config from "@config";

type OwnProps = $Exact<{
  onPageChange: Function,
  onSelectEmployee?: Function,
  currentPage?: number,
  selectEmployeeList?: PaginatedList<EmployeeType>,
  interactiveMode?: boolean, // Used for displaying just the selected employee (grid looks disabled and has only 1 record if set to false)
  selectedEmployee?: EmployeeType, // It is coming from linear wizard...
  data?: EmployeeType, // It is coming from linear wizard...
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class SelectEmployeeGrid extends React.Component<Props> {
  selectEmployee = (employee: EmployeeType) => () => {
    if (this.props.onSelectEmployee) this.props.onSelectEmployee(employee);
  };

  get pagination() {
    const pagination = (this.props.selectEmployeeList || {}).pagination;

    return {
      ...pagination,
      totalPages: Math.ceil(
        (this.props.selectEmployeeList || {}).totalElements / pagination.pageSize,
      ),
    };
  }
  get rowData() {
    if ((this.props.selectEmployeeList || {}) && this.props.interactiveMode)
      return (this.props.selectEmployeeList || {}).content;
    else if (!this.props.interactiveMode && this.props.selectedEmployee)
      return [this.props.selectedEmployee];
    return [];
  }
  get columns() {
    const columnsConfig = [
      {
        key: "employeeRefPrimary",
        name: this.props.t("EMPLOYEE_REF"),
        width: 150,
        align: "left",
      },
      {
        key: "firstName",
        align: "left",
        width: 150,
        name: this.props.t("FIRST_NAME"),
      },
      {
        key: "lastName",
        align: "left",
        width: 150,
        name: this.props.t("SURNAME"),
      },
      {
        key: "department",
        align: "left",
        name: this.props.t("DEPARTMENT"),
        renderCell: ({ row }: { row: EmployeeType }) => {
          const orgUnit = row.employmentSummary.organisationalUnits;
          if (orgUnit.length < 1) return this.props.t("N/A");
          return (orgUnit || []).join(",");
        },
      },
    ];
    if (this.props.interactiveMode) {
      columnsConfig.push({
        name: "",
        key: "actions",
        width: 100,
        onCellClick: ({ row }: { row: EmployeeType }) => {
          this.selectEmployee(row);
        },
        renderCell: ({ row }: { row: EmployeeType }) => {
          return (
            <div className="d-flex align-items-center pointer">
              <span>{this.props.t("SELECT")}</span>
              <Icons.ArrowRightIcon className="ml-1" />
            </div>
          );
        },
      });
    }
    return columnsConfig;
  }

  render() {
    if (this.rowData.length < 1) return <div />;
    return (
      <div>
        <GSGrid rows={this.rowData} columns={this.columns} />
        {this.props.interactiveMode && (
          <Pagination
            className="d-flex justify-content-center"
            currentPage={this.pagination.pageNumber}
            totalPages={this.pagination.totalPages}
            onChange={this.props.onPageChange}
          />
        )}
      </div>
    );
  }
}

export default localize()(SelectEmployeeGrid);
